import { Box, Text, useDisclosure } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import BannerSlot from '../BannersGrid/Banner';
import BannerForm from '../BannersGrid/BannerForm';
import context from '../context';

const ASPECTO_BANNER = 226 / 295;

const Banner: React.FC = () => {
  const { pageGroup } = useContext(context);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [clickedBanner, setClickedBanner] = useState<any | undefined>(
    undefined,
  );

  const banner = (pageGroup?.items ?? [])[0];

  const fechar = () => {
    setClickedBanner(undefined);
    onClose();
  };

  return (
    <>
      <Text fontSize="sm" color="gray.600" mb={3}>
        Banner vertical exibido como primeiro item da faixa, antes dos produtos
        da coleção.
      </Text>

      <Box maxW="200px">
        <BannerSlot
          banner={banner}
          index={0}
          papel="Banner da vitrine"
          aspectRatio={ASPECTO_BANNER}
          onClick={b => {
            setClickedBanner(b);
            onOpen();
          }}
        />
      </Box>

      <BannerForm
        isOpen={isOpen}
        banner={clickedBanner}
        onClose={fechar}
        onSaved={fechar}
      />
    </>
  );
};

export default Banner;
